module.exports = __webpack_public_path__ + "static/media/24hundred_shortcut.41acfcbe.png";